import { ContributionType } from 'helpers/constants';

export const PURCHASE_MODAL_TITLES = {
  [ContributionType.contributionCourse]: {
    button: 'Purchase',
    modal: 'Purchase Group Course',
    submit: 'Reserve',
  },
  [ContributionType.contributionMembership]: {
    button: 'Purchase',
    modal: 'Purchase Membership',
    submit: 'Reserve',
  },
  [ContributionType.contributionOneToOne]: {
    button: 'Reserve 1:1 Session',
    modal: 'Reserve 1:1 Session',
    submit: 'Reserve',
  },
  [ContributionType.contributionLocalEvent]: {
    button: '',
    modal: '',
    submit: '',
  },
};

export const PURCHASE_MODAL_STEPS = {
  memberLoggedIn: 'memberLoggedIn',
  loggedIn: 'loggedIn',
  init: 'init',
  memberInit: 'memberInit',
  login: 'login',
  memberLogin: 'memberLogin',
  create: 'create',
  memberCreate: 'memberCreate',
};

export const ACCOUNT_FORM_HEADERS = {
  loggedIn: '',
  memberLoggedIn: '',
  init: 'Login or Create Your Account',
  memberInit: 'Login or Create Your Account',
  join: 'Login or Create Your Account',
  login: 'Login to Your Account',
  memberLogin: 'Login to Your Account',
  create: 'Create Your Account',
  memberCreate: 'Create Your Account',
};

export const ACCOUNT_FORM_FIELDS = {
  confirmEmail: 'ConfirmEmail',
  email: 'Email',
  password: 'Password',
  birthDate: 'BirthDate',
  firstName: 'FirstName',
  lastName: 'LastName',
  timeZoneId: 'TimeZoneId',
};

export const RESTORE_PASS = 'restore-pass';

export const PAYMENTS_STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
};
